import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TabPanel from "../../utils/TabPanel";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import ManageHeadAndSubHead from "./ManageHeadAndSubHead";
import ManageService from "./ManageService";
import ServiceDetailView from './ServiceDetailView';
import SubHeadDetailView from './SubHeadDetailView';
import HeadDetailView from './HeadDetailView';
import ShowService from './ShowService';
import ManageBusinessSequence from "./ManageBusinessSequence";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    getHeadByBusinessId,
    getHeadSubheadHierarchy,
    deleteHeadSubheadService,
    getServicesByBusinessId,
    uploadServices,
    updateService,
    deleteMultipleServices,
    clearMsg,
    deleteSubcategoryButton,
    getServicesMenuExportToExcel,
    getPetPoojaMenuExportToExcel,

} from '../../../actions/businessActions';
import HeadSubheadTable from "./HeadSubheadTable";
import ServiceTable from './ServiceTable';
import BulkUpload from '../../common/FileUploader';
import Tooltip from '@material-ui/core/Tooltip';
import { CSVLink } from "react-csv";
import ManageVariationGroups from "./ManageVariationGroup";
import ManageAddonList from "./ManageAddon/ManageAddonList";
import Linking from "./ManageAddon/Linking";
import { variationGroupsToLinkCatalogItem } from "../../../actions/variationsAction";
import LinkedAddonsModal from "./LinkedAddonsModal";
import Modal from "@material-ui/core/Modal";
import { updateVariationsFlag } from "../../../actions/variationsAction"
import SecureActionAuthDialog from "../../common/SecureActionAuthDialog";
import { Container } from "@material-ui/core";
import getBrandName from "../../../utils/brandUtils";
import AddonGroup from "./ManageAddonGroup/AddonGroup";


/* Deleting more than this many catalogue items in one go asks for the login
   password. Kept in sync with BULK_DELETE_REAUTH_THRESHOLD in
   server/utils/passwordReauth.js, which is what actually enforces it. */
const BULK_DELETE_AUTH_THRESHOLD = 5;

const styles = (theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    container: {
        width: "100%"
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    tab: {
        '& .MuiBox-root': {
            padding: '0px',
        },
    },
    headers: {
        fontSize: '10px'
    },
    tabPadding: {
        minWidth: "100px"
    }
});

class ServiceSection extends Component {
    constructor() {
        super();
        this.state = {
            value: 0,
            serviceModalOpen: false,
            headModalOpen: false,
            subHeadModalOpen: false,
            edit: false,
            headsubHeadData: {},
            editService: false,
            serviceData: {},
            showService: false,
            selectedService: {},
            order: - 1,
            orderBy: "service",
            page: 0,
            rowsPerPage: 50,
            pageOfHeadSubHead: 0,
            rowsPerPageOfHeadSubHead: 10,
            snackOpen: false,
            sucessMsg: null,
            errorMsg: null,
            parentHead: {},
            serviceFilter: {},
            headSubheadFilter: {},
            numSelected: "",
            numSelectedSubHead: "",
            selected: [],
            headSubheadSelected: [],
            selectedSubHead: [],
            modalDeleteOpen: false,
            deleteAuthDialogOpen: false,
            pendingDeleteCount: 0,
            headModalDeleteOpen: false,
            subHeadModalDeleteOpen: false,
            showDownloadIcon: false,
            showDownloadExcelIcon: false,
            searchedSubhead: "",
            searchedHead: "",
            headers: [
                { key: 'serviceId', label: 'itemId' },
                { key: 'petPoojaItemId', label: 'petPoojaItemId' },
                { key: 'petPoojaVariationId', label: 'petPoojaVariationId' },
                { key: 'variation.variationId', label: 'XirifyVariationID' },
                { key: 'variation.variationGroupName', label: 'XirifyVariationGroupName' },
                { key: 'service', label: 'itemName' },
                { key: 'description', label: 'itemDescription' },
                { key: 'cost.costType', label: 'itemCostType' },
                { key: 'cost.from', label: 'itemCostFrom' },
                { key: 'cost.to', label: 'itemCostTo' },
                { key: 'cost.fixedCost', label: 'itemFixedCost' },
                { key: 'cost.quantity', label: 'Quantity' },
                { key: 'cost.unit', label: 'itemUnit' },
                { key: 'servicesPackagingCharges', label: 'itemPackagingCharges' },
                { key: 'cost.gstConf.gst', label: 'itemGst (5%, 12%, 18%, 28%)' },
                { key: 'cost.gstConf.cgst', label: 'itemCgst' },
                { key: 'cost.gstConf.sgst', label: 'itemSgst' },
                { key: 'cost.gstConf.igst', label: 'itemIgst' },
                { key: 'isEnabled', label: 'itemIsEnabled' },
                { key: 'allowLooseQuantity', label: 'itemAllowLooseQuantity' },
                { key: 'foodType', label: 'itemFoodType' },
                { key: 'availability.isActive', label: 'itemAvailabilityIsActive' },
                { key: 'isDisplay', label: 'itemIsDisplay' },
                { key: 'mustTry', label: 'itemMustTry' },
                { key: 'newArrival', label: 'itemNew' },
                { key: 'excludeItemTags', label: 'excludeItemTagsFlag' },
                { key: 'workingHours', label: 'itemWorkingHrs' },
                { key: 'availability.holidays', label: 'itemHolidays' },
                { key: 'itemPhotos', label: 'itemPhotos' },
                { key: 'headSubHead', label: 'itemsHeads' },
                { key: 'serviceOffers.discount.offers[0].discountType', label: 'itemDiscountTypeOne(FLAT,PERCENTAGE)' },
                { key: 'serviceOffers.discount.offers[0].off', label: 'itemDiscountOffOne' },
                { key: 'serviceOffers.discount.offers[0].maxDiscountCap', label: 'itemMaxDiscountCapOne' },
                { key: 'serviceOffers.discount.offers[0].isActive', label: 'itemDiscountIsActiveOne' },

                { key: 'serviceOffers.discount.offers[1].discountType', label: 'itemDiscountTypeTwo(FLAT,PERCENTAGE)' },
                { key: 'serviceOffers.discount.offers[1].off', label: 'itemDiscountOffTwo' },
                { key: 'serviceOffers.discount.offers[1].maxDiscountCap', label: 'itemMaxDiscountCapTwo' },
                { key: 'serviceOffers.discount.offers[1].isActive', label: 'itemDiscountIsActiveTwo' },

                { key: 'serviceOffers.discount.offers[2].discountType', label: 'itemDiscountTypeThree(FLAT,PERCENTAGE)' },
                { key: 'serviceOffers.discount.offers[2].off', label: 'itemDiscountOffThree' },
                { key: 'serviceOffers.discount.offers[2].maxDiscountCap', label: 'itemMaxDiscountCapThree' },
                { key: 'serviceOffers.discount.offers[2].isActive', label: 'itemDiscountIsActiveThree' },
                { key: 'addOnChildServiceItems', label: 'SingleAddOnId' },
                { key: 'linkedAddOnGroups', label: 'AddnOnGroupId' },
                { key: 'itemCalories', label: 'itemCalories' },
                { key: 'itemProtein', label: 'itemProtein' },
                { key: 'itemBrandName', label: 'itemBrandName' },
                { key: 'itemBrandLogo', label: 'itemBrandLogo' },
                { key: 'itemHeadImage', label: 'itemHeadImage' },
                { key: 'itemCountryOfOrigin', label: 'itemCountryOfOrigin' },
                { key: 'itemCountryLogo', label: 'itemCountryLogo' },
                { key: 'FSSAILicNumber', label: 'FSSAILicNumber' },
                { key: 'ProductDescription', label: 'Highlights(Title;Value;Description; " ~ marks empty field" )' },
            ],

            petpoojaheaders: [
                { key: 'itemid', label: 'petPoojaItemId' },
                { key: 'itemvariationid', label: 'petPoojaVariationId' },
                { key: 'itemname', label: 'petPoojaItemName' },
                { key: 'itemdescription', label: 'petPoojaItemDescription' },
                { key: 'price', label: 'petPoojaItemPrice' },
                { key: 'itemtype', label: 'petPoojaItemType' },
                { key: 'item_attributeid', label: 'petPoojaItemFoodType' },
                { key: 'in_stock', label: 'petPoojaItemInStockCount' },
                { key: 'taxes', label: 'taxId,taxName,tax(%)' },
                { key: 'item_ordertype', label: 'petPoojaItemOrderType' },
                { key: 'item_image_url', label: 'petPoojaItemImageUrl' },
                { key: 'item_packingcharges', label: 'petPoojaItemPackingCharges' },
                { key: 'minimumpreparationtime', label: 'petPoojaMinimumPreparationTime' },
                { key: 'itemCategoryData.categoryname', label: 'petPoojaItemCategoryName' },
                { key: 'variation_groupname', label: 'petPoojaVariationGroupName' },
                { key: 'discountType', label: 'Discount Type' },
                { key: 'off', label: 'Off' },
                { key: 'maxDiscountCap', label: 'Max Discount Cap' }
            ],
            itemTags: "",
            isAddonLinked: "",
            variations: "",
            variationGroupName: "",
            handleLinkedAddonModalOpen: false,
            itemIdToFetchAddon: ""
        };
    }

    getHeadersWithBrandName() {
        const brandName = getBrandName(this.props.dashboard);
        return this.state.headers.map(h => {
            if (h.label === 'XirifyVariationID') return { ...h, label: `${brandName}VariationID` };
            if (h.label === 'XirifyVariationGroupName') return { ...h, label: `${brandName}VariationGroupName` };
            return h;
        });
    }

    componentDidMount = async () => {
        await this.filterServices();
        this.getHeadSubheads()
        if (this.state.headSubheadSelected.length > 0 || this.state.selectedSubHead.length > 0) {
            await this.editheadSubhead();
            this.openSubheadModal();
            this.openHeadModal();
        }

    };

    componentDidUpdate(prevProps, prevState) {
        if ((prevState.sucessMsg === null && this.state.sucessMsg) ||
            (prevState.errorMsg === null && this.state.errorMsg)) {
            this.setState({ snackOpen: true });
        }
        if (prevState.sucessMsg !== this.state.sucessMsg) {
            this.fetchServices();
        }
        if (this.state.headSubheadSelected.length > 0 || this.state.selectedSubHead.length > 0) {
            this.editheadSubhead();
        }
        if (this.props.business.bulkUploadSuccess) {
            this.setState({ sucessMsg: this.props.business.bulkUploadSuccess })
            this.setState({ snackOpen: true });
            this.props.clearMsg();
            this.getHeadSubheads();
            this.fetchServices();
            // Backend processes upload asynchronously and returns immediately.
            // Re-fetch after the snackbar closes (2s) to get fully-linked head/subhead data.
            clearTimeout(this.uploadRefetchTimer);
            this.uploadRefetchTimer = setTimeout(() => {
                this.props.getHeadByBusinessId(this.props.businessDetails._id);
                this.getHeadSubheads();
                this.fetchServices();
            }, 2500);
        } else if (this.props.business.bulkUploadError) {
            this.setState({ errorMsg: this.props.business.bulkUploadError });
            this.setState({ snackOpen: true });
            this.props.clearMsg();
        } else if (this.props.business.deleteSubcategoryMsg) {
            this.setState({ sucessMsg: this.props.business.deleteSubcategoryMsg });
            this.setState({ snackOpen: true });
            this.props.clearMsg();

        } else if (this.props.business.sucessMsgAddon) {
            this.setState({ sucessMsg: this.props.business.sucessMsgAddon });
            this.setState({ snackOpen: true });
            this.props.clearMsg();

        } else if (this.props.business.sucessMsgAddon) {
            this.setState({ sucessMsg: this.props.business.sucessMsgAddon });
            this.setState({ snackOpen: true });
            this.props.clearMsg();
        }

        // When allServices refreshes while the edit modal is open with a service that has no heads yet,
        // update serviceData so the edit form gets the newly-linked head/subhead data.
        if (
            this.state.editService &&
            this.state.serviceData?._id &&
            prevProps.business?.allServices?.data !== this.props.business?.allServices?.data &&
            this.props.business?.allServices?.data
        ) {
            const freshData = this.props.business.allServices.data.find(
                s => s._id === this.state.serviceData._id
            );
            if (
                freshData &&
                freshData.heads?.length > 0 &&
                (!this.state.serviceData.heads || this.state.serviceData.heads.length === 0)
            ) {
                this.setState({ serviceData: freshData });
            }
        }
    }
    handleSnackClose = () => {
        this.props.clearMsg();
        this.setState({
            snackOpen: false,
            modalDeleteOpen: false,
            errorMsg: null,
            sucessMsg: null
        });
        this.fetchServices();
        this.getHeadSubheads();
        this.props.getHeadByBusinessId(this.props.businessDetails._id);
    }

    handleChangeTab = (event, newValue) => {
        this.setState({ value: newValue });
    };
    openServiceModal = async () => {
        let payload = { businessId: this.props.businessDetails._id }
        await this.props.variationGroupsToLinkCatalogItem(payload)
        await this.props.getHeadByBusinessId(this.props.businessDetails._id)
        this.setState({ serviceModalOpen: true });
    }
    closeServiceModal = () => {
        this.setState({ editService: false, serviceModalOpen: false });
    }
    openHeadModal = () => {
        this.setState({ headModalOpen: true });
    }
    closeHeadModal = () => {
        this.setState({ headModalOpen: false, edit: false });
    }
    openSubheadModal = () => {
        this.props.getHeadByBusinessId(this.props.businessDetails._id)
        this.setState({ subHeadModalOpen: true });
    }
    closeSubheadModal = () => {
        this.setState({ subHeadModalOpen: false, edit: false });
    }
    openShowService = () => {
        this.setState({ showService: true });
    }
    closeShowService = () => {
        this.setState({ showService: false });
    }
    getHeadSubheads = async () => {
        let data = {
            id: this.props.businessDetails._id,
            data: {
                head: this.state.headSubheadFilter && this.state.headSubheadFilter.head ? this.state.headSubheadFilter.head : null,
                subhead: this.state.headSubheadFilter && this.state.headSubheadFilter.subhead ? this.state.headSubheadFilter.subhead : null,
                rowsPerPage: this.state.rowsPerPageOfHeadSubHead,
                skip: this.state.pageOfHeadSubHead * this.state.rowsPerPageOfHeadSubHead
            }
        }
        await this.props.getHeadSubheadHierarchy(data);
    }

    handleDeleteOpen = () => {
        this.setState({
            modalDeleteOpen: true,
        });
    }

    deleteClose = () => {
        this.setState({ modalDeleteOpen: false });
    }
    handleDeleteOpenForHeadSubHead = () => {
        this.setState({
            headModalDeleteOpen: true,
        });
    }

    deleteCloseForHeadSubHead = () => {
        this.setState({ headModalDeleteOpen: false });
    }
    handleDeleteOpenForSubHead = () => {
        this.setState({
            subHeadModalDeleteOpen: true,
        });
    }

    deleteCloseForSubHead = () => {
        this.setState({ subHeadModalDeleteOpen: false });
    }

    /* Confirming the warning deletes a small batch straight away. A larger
       batch is destructive enough to ask for the login password first. */
    confirmDeleteMultiServices = () => {
        if (this.state.selected.length > BULK_DELETE_AUTH_THRESHOLD) {
            /* Pinned here because the dialog copy quotes the count, and a
               successful delete clears the selection while it is still up. */
            this.setState({
                modalDeleteOpen: false,
                deleteAuthDialogOpen: true,
                pendingDeleteCount: this.state.selected.length,
            });
            return;
        }
        this.deleteMultiServices();
    }

    handleDeleteAuthDialogClose = () => {
        this.setState({ deleteAuthDialogOpen: false });
    }

    /**
     * Deletes the selected items. When a password is supplied the server
     * re-verifies it before deleting anything, and the result is returned so
     * the password dialog can stay open and show the failure.
     *
     * @param {string} [password] login password, for batches past the threshold
     * @returns {Promise<{ success: boolean, error?: string }>}
     */
    deleteMultiServices = async (password) => {
        let payload = {
            businessId: this.props.businessDetails._id,
            data: {
                serviceIds: this.state.selected
            }
        }
        if (password) payload.password = password;

        const result = await this.props.deleteMultipleServices(payload)

        /* A rejected password must not clear the selection - the user is about
           to retry with exactly the same items. */
        if (password && result && !result.success) {
            return result;
        }

        this.setState({ selected: [] })
        this.fetchServices();
        this.deleteClose();
        return result || { success: true };
    }

    deleteheadSubhead = async () => {
        let data = [];
        let _id = [];
        let selectedHeadSubHeadData = this.state.headSubheadSelected
        let allHeadSubHeadData = this.props.business.headSubheadHeirarchy.data
        let selectedSubHeadData = this.state.selectedSubHead


        if (this.state.headSubheadSelected && this.state.headSubheadSelected.length > 0) {

            for (let i = 0; i < allHeadSubHeadData.length; i++) {
                const elementFirst = allHeadSubHeadData[i];
                for (let j = 0; j < selectedHeadSubHeadData.length; j++) {
                    const elementSecond = selectedHeadSubHeadData[j];
                    if (elementFirst._id === elementSecond) {
                        data.push(elementFirst)
                    }
                }
            }

            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                _id.push(element._id)
            }

        }

        if (this.state.selectedSubHead && this.state.selectedSubHead.length > 0) {
            let subHead = []
            let finalSubHead = []
            for (let i = 0; i < allHeadSubHeadData.length; i++) {
                if (!allHeadSubHeadData[i].hasOwnProperty("children")) {
                    continue;
                }
                let allChildrens = allHeadSubHeadData[i].children;
                subHead.push(allChildrens);
            }
            for (let j = 0; j < subHead.length; j++) {
                finalSubHead.push(...subHead[j])

            }
            for (let a = 0; a < finalSubHead.length; a++) {
                const elementA = finalSubHead[a];
                for (let b = 0; b < selectedSubHeadData.length; b++) {
                    const elementB = selectedSubHeadData[b];
                    if (elementA._id === elementB) {
                        data.push(elementA)
                    }

                }

            }
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                _id.push(element._id)
            }

        }
        let payload = {
            businessId: data[0].businessId,
            type: data[0].type,
            id: _id
        };
        await this.props.deleteHeadSubheadService(payload);
        this.setState({ headSubheadSelected: [] });
        this.setState({ selectedSubHead: [] });
        await this.getHeadSubheads();
        this.fetchServices();
        await this.props.getHeadByBusinessId(this.props.businessDetails._id);
        this.deleteCloseForHeadSubHead();
    }
    editheadSubhead = (head) => {
        if (!head) return
        var parentsName;
        let data = {};
        this.setState({
            edit: true,
            headsubHeadData: head
        })
        if (head.type === "SubHead") {
            if (this.props.business.Heads) {
                this.props.business.Heads.map((parent) => {
                    if (parent._id.toString() === head.parentId.toString()) {
                        parentsName = parent.name
                    }
                })
            }

            let parentHead = this.props.business && this.props.business.Heads &&
                this.props.business.Heads.find(tempHead => tempHead._id.toString() === head.parentId.toString());
            if (parentsName) {
                data = head
                data.parentsName = parentsName;
            }
            this.setState({
                headsubHeadData: data,
                parentHead: parentHead
            })
            this.openSubheadModal();
        }
        else if (head.type === "Head") {
            this.openHeadModal();
        }
    }
    editService = (service) => {
        this.setState({
            editService: true,
            serviceData: service
        })
        this.openServiceModal();
    }
    handleListItemClick = (data) => {
        this.openShowService();
        this.setState({ selectedService: data });
    }

    setOrder = (order) => {
        this.setState({ order }, () => this.fetchServices());
    };

    setOrderBy = (orderBy) => {
        this.setState({ orderBy }, () => this.fetchServices());
    };

    setPage = (page) => {
        this.setState({ page }, () => this.fetchServices());
    };

    setRowsPerPage = (rowsPerPage) => {
        this.setState({ rowsPerPage });
    };
    setPageOfHeadSubHead = (page) => {
        this.setState({ pageOfHeadSubHead: page }, () => this.getHeadSubheads());
    };
    setRowsPerPageOfHeadSubHead = (rowsPerPage) => {
        this.setState({ rowsPerPageOfHeadSubHead: rowsPerPage });
    };


    bulkUpload = (file) => {
        let payload = {
            businessId: this.props.businessDetails._id,
            file: file
        }
        this.props.uploadServices(payload);
    }


    handleSwitchChange = async (event, service) => {
        let groupPayload = {}

        let updatePayload = {};
        if (event.target.name === 'availability') {
            let availabilityData = service.availability;
            availabilityData.isActive = event.target.checked;
            updatePayload.availability = availabilityData;
            if (service.variation?.variationGroupObjectId) {
                groupPayload.variationGroupId = service.variation?.variationGroupObjectId;
                groupPayload.serviceId = service._id;
                groupPayload.availability = availabilityData.isActive
            }
        } else {
            updatePayload[event.target.name] = event.target.checked;
            if (service.variation?.variationGroupObjectId) {
                groupPayload.variationGroupId = service.variation?.variationGroupObjectId;
                groupPayload.serviceId = service._id;
                groupPayload[event.target.name] = event.target.checked;
            }
        }

        if (service.variation?.variationGroupObjectId) {
            await this.props.updateVariationsFlag(groupPayload)
        }

        let payload = {
            serviceId: service._id,
            data: updatePayload
        }
        await this.props.updateService(payload);
        this.fetchServices();
    }

    fetchServices = async (data) => {
        let payload = {
            id: this.props.businessDetails._id,
            data: {
                orderBy: this.state.orderBy,
                order: this.state.order,
                rowsPerPage: this.state.rowsPerPage,
                skip: this.state.page * this.state.rowsPerPage,
                service: this.state.serviceFilter && this.state.serviceFilter.service ? this.state.serviceFilter.service : null,
                head: this.state.serviceFilter && this.state.serviceFilter.head ? this.state.serviceFilter.head : null,
                subhead: this.state.serviceFilter && this.state.serviceFilter.subhead ? this.state.serviceFilter.subhead : null,
                availability: this.state.serviceFilter && this.state.serviceFilter.availability,
                isEnabled: this.state.serviceFilter && this.state.serviceFilter.isEnabled,
                isDisplay: this.state.serviceFilter && this.state.serviceFilter.isDisplay,
                itemTags: this.state.serviceFilter && this.state.serviceFilter.itemTags,
                variationGroupName: this.state.serviceFilter && this.state.serviceFilter.variationGroupName,
                variations: this.state.serviceFilter && this.state.serviceFilter.variations,
                isAddonLinked: this.state.serviceFilter && this.state.serviceFilter.isAddonLinked,
                foodType: this.state.serviceFilter && this.state.serviceFilter.foodType
            }
        }
        await this.props.getServicesByBusinessId(payload);
        this.setState({ showDownloadIcon: false });

    }
    clearFilter = async () => {
        await this.setState({
            serviceFilter: {},
            headSubheadFilter: {},
            handleLinkedAddonModalOpen: false

        });
    }
    filterServices = async (data) => {
        await this.setState({ serviceFilter: data, page: 0 });
        this.fetchServices();
    }
    setHeadSubheadFilter = async (data) => {
        await this.setState({ headSubheadFilter: data });
        this.getHeadSubheads();
    }
    setSelected = (selected) => {
        this.setState({ selected });
    }
    setSelectedHeadSubHead = (headSubheadSelected) => {
        this.setState({ headSubheadSelected });
    }
    setSelectedSubHead = (selectedSubHead) => {
        this.setState({ selectedSubHead });
    }
    removeSubcategory = async () => {
        let payload = {
            businessId: this.props.businessDetails._id
        };
        await this.props.deleteSubcategoryButton(payload);
    }

    fetchExportToExcel = async () => {
        let payload = {
            businessId: this.props.businessDetails._id,
            data: {
                orderBy: this.state.orderBy,
                order: this.state.order,
                service: this.state.serviceFilter && this.state.serviceFilter.service ? this.state.serviceFilter.service : null,
                head: this.state.serviceFilter && this.state.serviceFilter.head ? this.state.serviceFilter.head : null,
                subhead: this.state.serviceFilter && this.state.serviceFilter.subhead ? this.state.serviceFilter.subhead : null,
                availability: this.state.serviceFilter && this.state.serviceFilter.availability,
                isEnabled: this.state.serviceFilter && this.state.serviceFilter.isEnabled,
                isDisplay: this.state.serviceFilter && this.state.serviceFilter.isDisplay,
                itemTags: this.state.serviceFilter && this.state.serviceFilter.itemTags,
                foodType: this.state.serviceFilter && this.state.serviceFilter.foodType
            }
        }
        await this.props.getServicesMenuExportToExcel(payload);
        this.setState({ showDownloadIcon: true });
    }

    exportToExcelPetPoojaCatalog = async () => {
        let payload = {
            businessId: this.props.businessDetails._id,
        }
        await this.props.getPetPoojaMenuExportToExcel(payload);
        this.setState({ showDownloadExcelIcon: true });
    }

    // Helper function to process data for CSV export - ensures values stay in single cells
    // IMPORTANT: This function creates a deep copy to avoid mutating the original data structure
    processDataForCSV = (data) => {
        if (!data || !Array.isArray(data)) return [];
        
        return data.map(item => {
            // Create a deep copy to ensure we don't mutate the original data structure
            // This prevents the UI from being affected by CSV formatting
            const processedItem = JSON.parse(JSON.stringify(item));
            
            // Keep detail strings as plain text; CSVLink handles quoting
            if (processedItem.itemProductDetailDescription && typeof processedItem.itemProductDetailDescription === 'string') {
                processedItem.itemProductDetailDescription = processedItem.itemProductDetailDescription.replace(/\r?\n/g, " ").trim();
            }
            if (processedItem.ProductDescription && typeof processedItem.ProductDescription === 'string') {
                processedItem.ProductDescription = processedItem.ProductDescription.replace(/\r?\n/g, " ").trim();
            }
            
            // Ensure itemPhotos is a single string; CSVLink handles quoting
            // Only process if it's a string - preserve original structure for arrays/objects
            if (processedItem.itemPhotos) {
                if (typeof processedItem.itemPhotos === 'string') {
                    processedItem.itemPhotos = processedItem.itemPhotos.trim();
                }
                // If itemPhotos is an array or object, convert to string format first
                // This preserves the original data structure in the source
                else if (Array.isArray(processedItem.itemPhotos)) {
                    // Convert array to string format url1;url2 for CSV
                    const photoUrls = processedItem.itemPhotos
                        .map(photo => {
                            if (typeof photo === 'string') return photo;
                            if (photo && photo.path) return photo.path;
                            if (photo && typeof photo === 'object') return JSON.stringify(photo);
                            return '';
                        })
                        .filter(url => url)
                        .join(';');
                    if (photoUrls) {
                        processedItem.itemPhotos = photoUrls;
                    }
                }
            }
            
            return processedItem;
        });
    }

    setSearchedSubhead = (searchedSubhead) => {
        this.setState({ searchedSubhead: searchedSubhead });
    }

    setSearchedHead = (searchedHead) => {
        this.setState({ searchedHead: searchedHead });
    }

    handleLinkedAddonOpen = (_id) => {
        this.setState({ handleLinkedAddonModalOpen: true, itemIdToFetchAddon: _id })
    }
    handleLinkedAddonModalClose = async () => {
        this.setState({ handleLinkedAddonModalOpen: false, itemIdToFetchAddon: "" })
        await this.fetchServices();
    }

    render() {
        const { classes } = this.props;
        let muiAlert = null;
        let footerButton = null;
        if (this.state.sucessMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="success">
                {this.state.sucessMsg}
            </MuiAlert>
        } else if (this.state.errorMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
                {this.state.errorMsg}
            </MuiAlert>
        }

        return (
            <div style={{ padding: "0px" }}>

                <Grid container direction="row" >
                    <Grid>
                        <Tabs
                            value={this.state.value}
                            onChange={this.handleChangeTab}
                            indicatorColor="primary"
                            textColor="primary"
                            style={{ padding: "0px" }}
                        >
                            <Tab onClick={() => this.filterServices()} className={classes.tabPadding} label={this.props.user.role === "areaManager" ? "Manage Catalog" : "Catalog"} />
                            <Tab className={classes.tabPadding} label={this.props.user.role === "areaManager" ? "Manage Heads & Sub-Heads" : "Heads & Sub-Heads"} />
                            <Tab className={classes.tabPadding} label={this.props.user.role === "areaManager" ? "Manage Variation Groups" : "Variation Groups"} />
                            <Tab className={classes.tabPadding} label={"Addons"} />
                            <Tab className={classes.tabPadding} label={"Addon Groups"} />
                            <Tab className={classes.tabPadding} label={"LINKING"} />
                            {this.props.user.role === "areaManager" ? (
                                <Tab className={classes.tabPadding} label={"Manage Item Sequence"} />
                            ) : null}
                        </Tabs>
                    </Grid>
                    <Grid item xs={12} sm={6}></Grid>
                    {this.props.user.role === "areaManager" && this.state.value === 1 ? (
                        <Grid item xs={12} sm={12}>
                            <Button
                                style={{ float: "right", margin: "5px" }}
                                variant="contained"
                                color="primary"
                                onClick={this.handleDeleteOpenForHeadSubHead}
                                // onClick={this.deleteMultiServices}
                                disabled={this.state.headSubheadSelected.length < 1 && this.state.selectedSubHead.length < 1}
                            >
                                Delete
                            </Button>
                            <Button
                                style={{ float: "right", margin: "5px" }}
                                variant="contained"
                                color="primary"
                                onClick={this.openSubheadModal}
                            >
                                Add Sub-head
                            </Button>
                            <Button
                                style={{ float: "right", margin: "5px" }}
                                variant="contained"
                                color="primary"
                                onClick={this.openHeadModal}
                            >
                                Add Head
                            </Button>

                        </Grid>
                    ) : null}
                    <Container>
                        {this.props.user.role === "areaManager" && this.state.value === 0 ? (

                            <Grid item xs={12} sm={12}>
                                <Button
                                    style={{ float: "right", margin: "5px" }}
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleDeleteOpen}
                                    // onClick={this.deleteMultiServices}
                                    disabled={this.state.selected.length < 1}
                                >
                                    Delete
                                </Button>
                                <BulkUpload handleFile={this.bulkUpload} buttonName="CATALOG BULK UPLOAD" />
                                <Button
                                    style={{ float: "right", margin: "5px" }}
                                    variant="contained"
                                    color="primary"
                                    onClick={this.openServiceModal}
                                >
                                    Add Item
                                </Button>
                                {this.state.showDownloadIcon ?
                                    <CSVLink
                                        style={{ float: "right", margin: "10px" }}
                                        headers={this.getHeadersWithBrandName()}
                                        data={this.processDataForCSV(this.props.business.servicesMenuExcelRecords)}
                                        filename={this.props.businessDetails.businessName + ".csv"}
                                        className="btn btn"
                                        target="_blank"
                                    >
                                        <Tooltip title="Export to Excel">
                                            <img alt="Export To Excel" src="../../images/exportToExcel.png" width="25" height="25" />
                                        </Tooltip>
                                    </CSVLink>
                                    :
                                    <Button
                                        style={{ float: "right", margin: "5px" }}
                                        variant="contained"
                                        color="primary"
                                        onClick={this.fetchExportToExcel}
                                    >
                                        DOWNLOAD CATALOG
                                    </Button>
                                }
                                {this.state.showDownloadExcelIcon ?
                                    <CSVLink
                                        style={{ float: "right", margin: "10px" }}
                                        headers={this.state.petpoojaheaders}
                                        data={this.props.business.petPoojaMenuExcelRecords}
                                        filename={this.props.businessDetails.businessName + "_petPoojaCatalog.csv"}
                                        className="btn btn"
                                        target="_blank"
                                    >
                                        <Tooltip title="Export to Excel">
                                            <img alt="Export To Excel" src="../../images/exportToExcel.png" width="25" height="25" />
                                        </Tooltip>
                                    </CSVLink>
                                    :
                                    <Button
                                        style={{ float: "right", margin: "5px" }}
                                        variant="contained"
                                        color="primary"
                                        onClick={this.exportToExcelPetPoojaCatalog}
                                        disabled={!this.props.businessDetails.isPetpoojaEnabled === true}
                                    >
                                        Petpooja Catalog Download
                                    </Button>
                                }
                                <Button
                                    style={{ float: "right", margin: "5px", backgroundColor: "#d32f2f", color: "#fff" }}
                                    variant="contained"
                                    onClick={this.syncPetpoojaMenuCatalog}
                                    disabled={!this.props.businessDetails.isPetpoojaEnabled === true || this.state.petpoojaMenuSyncing}
                                >
                                    {this.state.petpoojaMenuSyncing ? 'Syncing...' : 'SYNC PETPOOJA MENU'}
                                </Button>

                            </Grid>

                        ) : null}
                    </Container>


                    {(this.props.user.role === "admin" && this.state.value === 0) || (this.props.user.role === "admin" && this.state.value === 1) ?
                        <Grid xs={12}>
                            <Button
                                style={{ float: "right", fontWeight: "bold", margin: "5px" }}
                                variant="contained"
                                color="secondary"
                                onClick={this.removeSubcategory}
                            >
                                REMOVE SUBCATEGORY FROM ALL SERVICES
                            </Button>
                            {this.state.showDownloadIcon ?
                                <CSVLink
                                    style={{ float: "right", margin: "10px" }}
                                    data={this.processDataForCSV(this.props.business.servicesMenuExcelRecords)}
                                    headers={this.getHeadersWithBrandName()}
                                    filename={this.props.businessDetails.businessName + ".csv"}
                                    className="btn btn"
                                    target="_blank"
                                >
                                    <Tooltip title="Export to Excel">
                                        <img alt="Export To Excel" src="../../images/exportToExcel.png" width="25" height="25" />
                                    </Tooltip>
                                </CSVLink>
                                :
                                <Button
                                    style={{ float: "right", margin: "5px" }}
                                    variant="contained"
                                    color="primary"
                                    onClick={this.fetchExportToExcel}
                                >
                                    DOWNLOAD CATALOG
                                </Button>
                            }
                        </Grid>
                        : null}
                    {(this.props.user.role === "regionalHead" && this.state.value === 0) || (this.props.user.role === "regionalHead" && this.state.value === 1) ?
                        <Grid xs={12}>
                            {this.state.showDownloadIcon ?
                                <CSVLink
                                    style={{ float: "right", margin: "10px" }}
                                    data={this.processDataForCSV(this.props.business.servicesMenuExcelRecords)}
                                    headers={this.getHeadersWithBrandName()}
                                    filename={this.props.businessDetails.businessName + ".csv"}
                                    className="btn btn"
                                    target="_blank"
                                >
                                    <Tooltip title="Export to Excel">
                                        <img alt="Export To Excel" src="../../images/exportToExcel.png" width="25" height="25" />
                                    </Tooltip>
                                </CSVLink>
                                :
                                <Button
                                    style={{ marginLeft: "850px" }}
                                    variant="contained"
                                    color="primary"
                                    onClick={this.fetchExportToExcel}
                                >
                                    DOWNLOAD CATALOG
                                </Button>
                            }
                        </Grid>
                        : null}
                    <TabPanel value={this.state.value} index={0} classes={{ root: classes.tab }}>
                        <Container>
                            <ManageService
                                // data={this.props.business.headSubheadHeirarchy.data}
                                data={this.props.business.Heads}
                                getServices={this.filterServices}
                                clearFilter={this.clearFilter}
                            />
                            {this.props.business.allServices && this.props.business.allServices.data ?
                                <ServiceTable
                                    rowData={this.props.business.allServices.data}
                                    totalCount={this.props.business.allServices.totalCount}
                                    order={this.state.order === 1 ? "asc" : "desc"}
                                    orderBy={this.state.orderBy}
                                    page={this.state.page}
                                    rowsPerPage={this.state.rowsPerPage}
                                    handleEditOpen={this.editService}
                                    handleListItemClick={this.handleListItemClick}
                                    setOrder={this.setOrder}
                                    setOrderBy={this.setOrderBy}
                                    setPage={this.setPage}
                                    setRowsPerPage={this.setRowsPerPage}
                                    history={this.props.history}
                                    role={this.props.user.role}
                                    // handleIsEnabledSwitchChange={this.handleIsEnabledSwitchChange}
                                    handleSwitchChange={this.handleSwitchChange}
                                    selected={this.state.selected}
                                    setSelected={this.setSelected}
                                    numSelected={this.state.numSelected}
                                    businessCategoryType={this.props.businessDetails.categoryType.name}
                                    isPetpoojaEnabled={this.props.businessDetails.isPetpoojaEnabled}
                                    handleLinkedAddonOpen={this.handleLinkedAddonOpen}
                                    handleLinkedAddonModalClose={this.handleLinkedAddonModalClose}

                                />
                                : null}
                        </Container>
                    </TabPanel>
                    {footerButton}

                    {/* <Grid container spacing={3}>
                    <Grid item className={classes.gridItem} xs={12} sm={6}>
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled={this.state.buttonDisabled}
                            onClick={this.handleDisableDialogOpen}
                            style={{  backgroundColor: "#f50505", color: "white" }}
                        >
                            RESET
                        </Button>
                    </Grid>
                </Grid> */}


                    <TabPanel style={{ width: "100%" }} value={this.state.value} index={1} classes={{ root: classes.tab }}>
                        <ManageHeadAndSubHead
                            businessDetails={this.props.businessDetails}
                            data={this.props.business.headSubheadHeirarchy.data}
                            getHeadSubheads={this.getHeadSubheads}
                            clearData={this.clearFilter}
                            headSubheadFilter={this.setHeadSubheadFilter}
                            setSearchedSubhead={this.setSearchedSubhead}
                            setSearchedHead={this.setSearchedHead}
                        />
                        {this.props.business.headSubheadHeirarchy.data ?
                            <HeadSubheadTable
                                rowData={this.props.business.headSubheadHeirarchy.data}
                                totalCount={this.props.business.headSubheadHeirarchy.totalCount}
                                order={this.state.order === 1 ? "asc" : "desc"}
                                orderBy={this.state.orderBy}
                                page={this.state.pageOfHeadSubHead}
                                rowsPerPage={this.state.rowsPerPageOfHeadSubHead}
                                handleEditOpenHeadSubhead={this.editheadSubhead}
                                handleDeleteHead={this.deleteheadSubhead}
                                skip={this.state.pageOfHeadSubHead * this.state.rowsPerPageOfHeadSubHead}
                                // setOrder={this.setOrder}
                                // setOrderBy={this.setOrderBy}
                                setPage={this.setPageOfHeadSubHead}
                                setRowsPerPage={this.setRowsPerPageOfHeadSubHead}
                                history={this.props.history}
                                role={this.props.user.role}
                                selected={this.state.headSubheadSelected}
                                setSelectedHeadSubHead={this.setSelectedHeadSubHead}
                                numSelected={this.state.numSelected}
                                searchedSubhead={this.state.searchedSubhead}
                                searchedHead={this.state.searchedHead}
                                selectedSubHead={this.state.selectedSubHead}
                                numSelectedSubHead={this.state.numSelectedSubHead}
                                setSelectedSubHead={this.setSelectedSubHead}
                            />
                            : null}
                    </TabPanel>
                    <TabPanel
                        style={{ width: "100%" }}
                        value={this.state.value}
                        index={2}
                        classes={{ root: classes.tab }}
                    >
                        <ManageVariationGroups
                            role={this.props.user.role}
                            businessDetails={this.props.businessDetails}
                        />

                    </TabPanel>

                    <TabPanel
                        style={{ width: "100%" }}
                        value={this.state.value}
                        index={3}
                        classes={{ root: classes.tab }}
                    >
                        <ManageAddonList
                            role={this.props.user.role}
                            businessDetails={this.props.businessDetails}
                        />

                    </TabPanel>

                    <TabPanel
                        style={{ width: "100%" }}
                        value={this.state.value}
                        index={4}
                        classes={{ root: classes.tab }}
                    >
                        <AddonGroup
                            role={this.props.user.role}
                            businessDetails={this.props.businessDetails}
                        />

                    </TabPanel>

                    <TabPanel
                        style={{ width: "100%" }}
                        value={this.state.value}
                        index={5}
                        classes={{ root: classes.tab }}
                    >
                        <Linking
                            role={this.props.user.role}
                            businessDetails={this.props.businessDetails}
                        />

                    </TabPanel>

                    <TabPanel
                        style={{ width: "100%" }}
                        value={this.state.value}
                        index={6}
                        classes={{ root: classes.tab }}
                    >
                        <ManageBusinessSequence
                            businessDetails={this.props.businessDetails}
                        />
                    </TabPanel>



                </Grid>

                <ServiceDetailView
                    open={this.state.serviceModalOpen}
                    onClose={this.closeServiceModal}
                    edit={this.state.editService}
                    data={this.state.serviceData}
                    businessDetails={this.props.businessDetails}
                    getHeadSubheads={this.getHeadSubheads}
                    getServices={this.fetchServices}
                />
                <HeadDetailView
                    open={this.state.headModalOpen}
                    onClose={this.closeHeadModal}
                    businessDetails={this.props.businessDetails}
                    edit={this.state.edit}
                    data={this.state.headsubHeadData}
                    headsLength={this.props.business.headSubheadHeirarchy.data && this.props.business.headSubheadHeirarchy.data.length > 0 ? this.props.business.headSubheadHeirarchy.data.length : 0}
                    getHeadSubheads={this.getHeadSubheads}
                />
                <SubHeadDetailView
                    open={this.state.subHeadModalOpen}
                    onClose={this.closeSubheadModal}
                    businessDetails={this.props.businessDetails}
                    edit={this.state.edit}
                    data={this.state.headsubHeadData}
                    parentHead={this.state.parentHead}
                    getHeadSubheads={this.getHeadSubheads}
                />
                <ShowService
                    open={this.state.showService}
                    onClose={this.closeShowService}
                    data={this.state.selectedService}
                />


                <Dialog
                    open={this.state.modalDeleteOpen}
                    onClose={this.deleteClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete Services</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Do you want to delete selected services?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.deleteClose} color="primary">
                            No
                        </Button>
                        <Button onClick={() => this.confirmDeleteMultiServices()} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>

                <SecureActionAuthDialog
                    open={this.state.deleteAuthDialogOpen}
                    username={this.props.user ? this.props.user.username : ""}
                    role={this.props.user ? this.props.user.role : ""}
                    subtitle="Password required to delete these items"
                    warningText={
                        <React.Fragment>
                            You are deleting{" "}
                            <strong>{this.state.pendingDeleteCount} catalogue items</strong>
                            {this.props.businessDetails
                                ? ` from ${this.props.businessDetails.businessName}`
                                : ""}
                            . Heads, subheads and the rest of the catalogue stay
                            untouched, but the selected items cannot be recovered.
                        </React.Fragment>
                    }
                    promptText={`Deleting more than ${BULK_DELETE_AUTH_THRESHOLD} items at once needs your login password. Please enter it to continue.`}
                    confirmLabel={`Delete ${this.state.pendingDeleteCount} Items`}
                    successMessage={`${this.state.pendingDeleteCount} items deleted successfully.`}
                    onClose={this.handleDeleteAuthDialogClose}
                    onConfirm={this.deleteMultiServices}
                />

                {this.state.headSubheadSelected.length > 0 ?
                    <Dialog
                        open={this.state.headModalDeleteOpen}
                        onClose={this.deleteCloseForHeadSubHead}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Delete Head</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure you want to delete head ?<br></br>
                                (Note: Deleting Head will delete all sub-heads within, if present.)
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.deleteCloseForHeadSubHead} color="primary">
                                No
                            </Button>
                            <Button onClick={() => this.deleteheadSubhead()} color="primary" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>
                    :
                    <Dialog></Dialog>
                }

                {this.state.selectedSubHead.length > 0 ?
                    <Dialog
                        open={this.state.headModalDeleteOpen}
                        onClose={this.deleteCloseForHeadSubHead}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Delete Sub-head</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure you want to delete sub-head ?<br></br>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.deleteCloseForHeadSubHead} color="primary">
                                No
                            </Button>
                            <Button onClick={() => this.deleteheadSubhead()} color="primary" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>
                    :
                    <Dialog></Dialog>
                }

                <Modal
                    open={this.state.handleLinkedAddonModalOpen}
                    className={classes.linkedItemsModal}
                    onClose={this.handleLinkedAddonModalClose}
                    closeAfterTransition
                >
                    <LinkedAddonsModal
                        handleLinkedAddonModalClose={this.handleLinkedAddonModalClose}
                        itemId={this.state.itemIdToFetchAddon}
                        role={this.props.user.role}
                        serviceSection={true}
                    />
                </Modal>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.snackOpen}
                    autoHideDuration={2000}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}>
                    {muiAlert}
                </Snackbar>

                <Backdrop className={classes.backdrop} open={this.props.business.isFetching}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        dashboard: state.dashboard,
        business: state.business,
        user: state.auth.user,
        admin: state.admin,
        categories: state.categories,
        env: state.auth.env
    };
};
export default connect(mapStateToProps, {
    getHeadByBusinessId,
    getHeadSubheadHierarchy,
    deleteHeadSubheadService,
    getServicesByBusinessId,
    uploadServices,
    updateService,
    deleteMultipleServices,
    clearMsg,
    deleteSubcategoryButton,
    getServicesMenuExportToExcel,
    getPetPoojaMenuExportToExcel,
    variationGroupsToLinkCatalogItem,
    updateVariationsFlag
})(withStyles(styles)(ServiceSection));
